// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import {Toast} from 'mint-ui';
import wx from 'weixin-js-sdk';
import 'iview/dist/styles/iview.css';    // 使用 CSS
import lrz from 'lrz'
import Vant from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import { Uploader, Dialog,DropdownMenu, DropdownItem,Field,Picker,DatetimePicker  } from 'vant';
import 'vant/lib/index.css';
import less from 'less'
Vue.use(less)
Vue.use(Uploader);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Field);
Vue.use(Picker);
Vue.use(DatetimePicker);

Vue.config.productionTip = false
Vue.use(MintUI);
Vue.use(wx)
Vue.use(Vant)
Vue.use(ElementUI);
import "@vant/touch-emulator";

import {loadOffline} from '@/components/Offline/assets/js/enterPageHandle'
loadOffline()


//axios 配置
axios.defaults.timeout = 60000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.baseURL = 'http://10.43.27.113:8608'
// axios.defaults.baseURL = 'http://10.43.25.14:8600/marketing'
Vue.prototype.$axios = axios

//POST传参序列化
axios.interceptors.request.use((config) => {
  return config;
}, (error) => {
  return Promise.reject(error);
});

//返回状态判断
axios.interceptors.response.use((res) => {
  //返回码为1为请求失败直接catch
  if (res.data.code == '1') {
    return Promise.reject(res);
  }
  if (res.data.code == '-1') {
    return Promise.reject(res);
  }
  return Promise.resolve(res);
}, (error) => {
  if(error.response.status == 428) {
    Toast({
      message: "验证码错误"
    })
    return Promise.reject(error);
  }
  Toast({
    message: "系统错误，请稍后重试"
  })
  //404等问题可以在这里处理
  return Promise.reject(error);
});



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js